import axios from 'axios'
import { Message } from 'element-ui'
import QS from 'qs'
import store from '../store';

// axios.defaults.timeout = 10000
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
var token = '';
const  instance = axios.create({
    // baseURL: '/',
    // baseURL: 'http://localhost:8777/',
    baseURL: 'http://api.newlong.com.cn/',
    timeout: 15000,
    paramsSerializer: function (params) {
        return QS.stringify(params)
    },
    // `withCredentials` 表示跨域请求时是否需要使用凭证
    withCredentials: false, // 默认的
    headers: {
        post: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    }
})

/**
 * *添加请求拦截器
 */
instance.interceptors.request.use(config => {
    // config.headers.t = 'ddd'
    // config.cancelToken = new CancelToken((c) => {
    //     if (config.headers.t == undefined)
    //         removePending(config, c)
    // })

    config.headers.t = getToken()
    return config
})

function getToken() {
    if (token === undefined || token === null || token === "") {
        token = localStorage.getItem("token");
    }
    return token;
}

function get(data) {
    instance.get(data.url, {
        params: data.params
    })
        .then(function (response) {
            if (data.callback != undefined) {
                if (response.status == 200) {
                    if (response.data.code == -999) {
                        store.commit('changeLoginState', false)
                        return
                    }
                    store.commit('changeLoginState', true)
                    if (response.data.code == 200) {
                        data.callback.success(response.data);
                    } else if (response.data.code == 404) {
                        data.callback.not_found()
                    } else if (response.data.code == 0) {
                        data.callback.err({ code: 0, msg: response.data.message, data: response.data })
                    } else {
                        data.callback.other(response.data);
                    }
                } else {
                    data.callback.err({ code: response.status, msg: response.statusText })
                }
            }
        })
        .catch(function (error) {
            if (data.callback != undefined)
                data.callback.err(error)
        })
}

function post(data) {
    instance.post(data.url, data.params)
        .then(function (response) {
            if (data.callback != undefined) {
                if (response.status == 200) {
                    if (data.url.indexOf('login') >= 0) {
                        if (response.data.code == 0) {
                            store.commit('changeLoginState', false)
                            data.callback.err(response.data)
                            return
                        }
                        token = response.data.data
                        localStorage.setItem("token",token)
                    } else if (response.data.code == -999) {
                        console.log("请登录")
                        store.commit('changeLoginState', false)
                        return
                    }
                    store.commit('changeLoginState', true)
                    data.callback.success(response.data)
                } else {
                    data.callback.err({ code: response.status, msg: response.statusText })
                }
            }
        })
        .catch(function (error) {
            if (data.callback != undefined)
                data.callback.err(error)
        })
}

function showAlert(msg) {
    Message({ message: msg, type: 'error' })
}
export default {
    showAlert, get, post
}